// uiSounds — tiny synthesized UI cues (no assets, no network).
//
// Khari, 2026-08-03: when an NPC answers in TEXT instead of voice, the player
// needs their focus taken to the chat — "a tick or ding sound (not annoying)."
// One short glassy tick, WebAudio-synthesized: sine with a 12ms attack and a
// fast exponential decay, quiet enough to sit under the radio. Deliberately
// NOT a notification "ding-dong" — it should read as the interface breathing,
// not the phone demanding.

let ctx = null;

function ac() {
  try {
    const C = window.AudioContext || window.webkitAudioContext;
    if (!C) return null;
    if (!ctx) ctx = new C();
    if (ctx.state === 'suspended') ctx.resume().catch(() => {});
    return ctx;
  } catch {
    return null;
  }
}

/** A soft "reply landed" tick. Safe to call anytime; silently no-ops
 *  pre-gesture or where WebAudio is unavailable. */
export function replyTick() {
  const c = ac();
  if (!c) return;
  try {
    const t = c.currentTime;
    const o = c.createOscillator();
    const g = c.createGain();
    o.type = 'sine';
    o.frequency.setValueAtTime(1318.5, t);          // E6 — glass, not doorbell
    g.gain.setValueAtTime(0.0001, t);
    g.gain.exponentialRampToValueAtTime(0.07, t + 0.012);
    g.gain.exponentialRampToValueAtTime(0.0001, t + 0.22);
    o.connect(g);
    g.connect(c.destination);
    o.start(t);
    o.stop(t + 0.24);
  } catch { /* a missed tick is nothing */ }
}
